// extracted by mini-css-extract-plugin
export default {"admin_wp":"Cabinet_admin_wp__w9rrk","ant-btn-primary":"Cabinet_ant-btn-primary__1+-oY","flex_course":"Cabinet_flex_course__rOm1t","tabs_wp":"Cabinet_tabs_wp__jZGLV"};